import React from "react";
import { Assets } from "../../assets";
import { useModalAnimation } from "../../hooks/animation/useModalAnimation";
import { useUiRedux } from "../../hooks/useUiRedux";

export const ModalViewImage = () => {
	const {
		state: { activeModalImageView, modalImageView },
		setActiveModalViewImage,
	} = useUiRedux();
	const { container } = useModalAnimation(activeModalImageView);
	return (
		<div ref={container} className="absolute z-30 h-full w-full bg-blacktransparent opacity-0 hidden">
			<div className="flex justify-center items-center w-full h-full ">
				<div className="relative bg-blue-200 w-[300px] md:lg-[w-600px] lg:w-[1000px]">
					<img className="h-full w-full" src={modalImageView} alt="imagen" />
					<div
						className="cursor-pointer absolute top-3 lg:top-5 right-5 w-6 h-6"
						onClick={() => {
							setActiveModalViewImage(false);
						}}
					>
						<img className="h-full w-full" src={Assets.icon.tache} alt="tache" />
					</div>
				</div>
			</div>
		</div>
	);
};
